

// src/components/MotionGalleryPage.js
import React from "react";
import "../styles/MotionGallery.css";

import Navbar from "./Navbar";
import useScrollToTop from "./useScrollToTop"; // ✅ imported correctly

const videos = [
  {
    title: "AirPods Product Animation – After Effects",
    src: "https://player.vimeo.com/video/1134874161?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "3D Product Reveal – Blender",
    src: "https://player.vimeo.com/video/1134874204?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Interactive Product Hover Card – Figma",
    src: "https://player.vimeo.com/video/1134874408?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Parallax Scrolling – After Effects",
    src: "https://player.vimeo.com/video/1134874262?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Logo Reveal – After Effects",
    src: "https://player.vimeo.com/video/1134874240?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Ice Cream Carousel – Figma",
    src: "https://player.vimeo.com/video/1134874330?loop=1&title=0&byline=0&portrait=0&dnt=1",
    
  },
  {
    title: "Paper Tear – After Effects",
    src: "https://player.vimeo.com/video/1134874139?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Zoom Transition – After Effects",
    src: "https://player.vimeo.com/video/1134874301?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Chess Board – After Effects",
    src: "https://player.vimeo.com/video/1134874374?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
  {
    title: "Text Reveal – After Effects",
    src: "https://player.vimeo.com/video/1134874284?loop=1&title=0&byline=0&portrait=0&dnt=1",
  },
];

export default function MotionGalleryPage() {
  useScrollToTop(); // 👈 This makes the page open at the top!

  return (
    <>
      {/* ✅ Navbar stays visible across the page */}
      <Navbar />

      <main className="mg-page" aria-label="All motion videos">

        

        {/* 🎥 Vimeo video gallery below the animation */}
        <section className="mg-stack">
          {videos.map((v, i) => (
            <article key={i} className="mg-entry">
              <div className="mg-titlebar">
                <h2>{v.title}</h2>
              </div>

              <div className="mg-video">
                <iframe
                  src={v.src}
                  title={v.title}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
            </article>
          ))}
        </section>
      </main>
    </>
  );
}

